import React, { useState, useEffect } from "react";
import ReCAPTCHA from "react-google-recaptcha";
import axios from "axios";
import { Link, Navigate } from "react-router-dom";
import LoginGoogle from "./LoginGoogle";
import "./Register.css";
import { useLanguage } from "../LanguageContext";

function Register(props){
  const { t } = useLanguage();

    const [userData, setUserData] = useState({
        username: "",
        email: "",
        password: "",
        password2: ""
    });
    const [error, setError] = useState(null);
    const [recaptcha, setRecaptcha] = useState(false);
    const [userLoggedIn, setUserLoggedIn] = useState(false);
    const [loading, setLoading] = useState(false);
    const [registerSuccess, setRegisterSuccess] = useState(false);
    // const bannedWords = props.bannedWords;
    
    // const recaptchaDone = false;
    // const [registerStatus, setRegisterStatus] = useState(false);

    useEffect(() => {
      window.scrollTo({
        top: 0,
        behavior: "instant"
    })
    }, []);

    function handleChange(event){
        const newValue = event.target.value;
        const inputName = event.target.name;

        setUserData(prevValue =>{
            if (inputName === "username"){
                return {
                    username: newValue,
                    email: prevValue.email,
                    password: prevValue.password,
                    password2: prevValue.password2
                };
              } else if (inputName === "email"){
                return {
                    username: prevValue.username,
                    email: newValue,
                    password: prevValue.password,
                    password2: prevValue.password2
                };
            } else if (inputName === "password"){
                return {
                    username: prevValue.username,
                    email: prevValue.email,
                    password: newValue,
                    password2: prevValue.password2
                };
            } else if (inputName === "password2"){
                return {
                    username: prevValue.username,
                    email: prevValue.email,
                    password: prevValue.password,
                    password2: newValue
                }
            }
        });
    };

    function registerUser(name, email, pass){
      // console.log("trying to register");
      setLoading(true);
      // axios.post(process.env.REACT_APP_REGISTER_USER_URL, {
      //     username: name,
      //     email: email,
      //     password: pass
      // }).then(response =>{
      //     setLoading(false);
      //     registerResponse(response);
      // }).catch(err =>{
      //     console.log(err);
      // });
      axios({
        method: "POST",
        data: {
          username: name,
          email: email,
          password: pass,
          ip: props.addressIp
        },
        withCredentials: true,
        url: process.env.REACT_APP_SERVER_URL + process.env.REACT_APP_REGISTER_USER_URL,
      }).then((res) => {
        setLoading(false);
        registerResponse(res);
      }).catch((err) =>{
        console.log(err);
      });
  };

  function registerResponse(response){

    if (response.data === "0"){
      setError(t("registerUsernameTaken"));
      setRegisterSuccess(false);
      return;
    } else if (response.data === "1"){
      setError(t("registerEmailTaken"));
      setRegisterSuccess(false);
      return;
    }

    switch (response.status){
        case 880:
          setError(t("registerUsernameTaken"));
          setRegisterSuccess(false);
        return t("registerUsernameTaken");
        case 881:
          setError(t("registerEmailTaken"));
          setRegisterSuccess(false);
            return t("registerEmailTaken");
        case 200:
            //successfully registered!
            // setRegisterStatus(true);
            // setUserStatus("UserRegisterSuccess");
            // props.setUserState("UserRegisterSuccess");
            window.location.href = '/rejestracja/sukces';
            break;
            default:
              setRegisterSuccess(false);
                return "Unknown register error!";
    };
};

function loginResponse(response){

  if (response.data?.banned) {
    setError(t("loginBanned") + (response.data.reason || t("loginBannedNoReason")));
    return;
  }

  if (response.data === "0"){
    // return "Niepoprawny login lub hasło.";
    setError(t("loginInvalidCredentials"));
    return;
  }

  const status = response.status;
  switch (status){
      case 881:
      return "Użytkownik o podanym emailu nie istnieje.";
      case 882:
      return "Podane hasło jest niepoprawne.";
      case 200:
          const { username, email, active, dataStatus, _id } = response.data;

          props.setUserData(response.data);
          props.setUserState("zalogowano pomyślnie");
          props.createCookie(response.data);
          setUserLoggedIn(true);

          break;
          default:
              return "Unknown login error!";
  };
};

    // function handleRegisterResponse(response){
    //     if (response === "+"){
    //     }
    //     else{
    //         setError(response);
    //     }
    // };

    function isValidUsername(username){
      // if (props.bannedWords === undefined){
      //   setError("Banned words is empty");
      //   return false;
      // }

      // console.log();

      for (let i = 0; i < props.bannedWords.length; i++) {
        if (username.includes(props.bannedWords[i])){
          setError(t("registerBannedName"));
          return false;
        }
      }
      
      // props.bannedWords.forEach(element => {
      //   if (username.includes(element)){
      //     setError("Nazwa użytkownika zawiera niedozwone słowo.");
      //     return false;
      //   }
      // });

      // if (username === "chuj"){
      //   setError("Nazwa użytkownika zawiera niedozwone słowo.");
      //   return false;
      // }

      if (userData.username.length <= 0){
        setError(t("registerEnterUsername"));
        return false;
      }

      if (userData.username.length > 30){
        setError(t("registerUsernameLimit"));
        return false;
      }

      return true;
      // return true;
    };

    function containsSpecialString(text){
      var format = /[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]+/;

  if(format.test(text)){
    return true;
  } else {
   return false;
  }
    };

    function isValidEmail(email){
        return /\S+@\S+\.\S+/.test(email);
    };

    function isVallidPassword(pass){

        if (pass.length <= 0){
            setError(t("loginEnterPassword"));
            return false;
        }
        else if (pass.length < 6)
        {
            setError(t("registerPasswordMinimum"));
            return false;
        }
        else if (pass.length > 100){
          setError(t("registerPasswordLimit"));
            return false;
        }

        if (pass !== userData.password2)
        {
            setError(t("registerPasswordMismatch"));
            return false;
        }

        if (recaptcha === false){
            setError(t("registerCaptchaError"));
            return false;
        }
        
        return true;
    };

    const handleSubmit = (event) =>{
      event.preventDefault();
      setRegisterSuccess(true);
        if (isValidUsername(userData.username) === false){
          return;
        }

        // if (containsSpecialString(userData.username) === true){
        //   setError("Nazwa użytkownika nie może zawierać znaków specjalnych.");
        //   return;
        // }

        if (!isValidEmail(userData.email))
        {
            if (userData.email.length <= 0){
                setError(t("loginEnterEmail"));
            }else {
                setError(t("loginInvalidEmail"));
            }
            return;
        }

        if (!isVallidPassword(userData.password))
        {
            return;
        }

        setError(null);

        // props.register(userData.username, userData.email, userData.password, handleRegisterResponse);
        // registerUser(userData.username, userData.email, userData.password, handleRegisterResponse);
        registerUser(userData.username, userData.email, userData.password);
    };

    function handleRecaptcha(){
        setRecaptcha(!recaptcha);
    };

    if (userLoggedIn){
      return <Navigate to={"/"} />
    } else {
    return(
        <main className="register-page">
          <header className="register-heading"><p>{t("registerKicker")}</p><h1>{t("register")}</h1><span>{t("registerIntro")}</span></header>
          <div className="register-layout">
            <section className="register-form-section"><h2>{t("registerFormTitle")}</h2>
          <form className="register-form" onSubmit={handleSubmit}>
            {/* <div className="form-group">
              <label htmlFor="username">nazwa użytkownika:</label>
              <input type="text" className="form-control" name="username" onChange={handleChange} value={userData.username}></input>
            </div> */}
            <div className="register-field">
              <label htmlFor="floatingUserName">{t("username")}</label>
              <input type="text" className="form-control" id="floatingUserName" placeholder={t("usernamePlaceholder")} name="username" onChange={handleChange} value={userData.username}></input>
            </div>

            {/* <div className="form-group">
              <label htmlFor="email">email:</label>
              <input type="email" className="form-control" name="email" onChange={handleChange} value={userData.email}></input>
            </div> */}
            <div className="register-field">
              <label htmlFor="floatingEmail">{t("contactEmail")}</label>
              <input type="email" className="form-control" id="floatingEmail" placeholder={t("emailPlaceholder")} name="email" onChange={handleChange} value={userData.email}></input>
            </div>

            {/* <div className="form-group">
              <label htmlFor="password">hasło:</label>
              <input type="password" className="form-control" name="password" onChange={handleChange} value={userData.password}></input>
            </div> */}
            <div className="register-field">
              <label htmlFor="floatingPassword">{t("password")}</label>
              <input type="password" className="form-control" id="floatingPassword" placeholder={t("passwordPlaceholder")} name="password" onChange={handleChange} value={userData.password}></input>
            </div>

            {/* <div className="form-group">
              <label htmlFor="password2">powtórz hasło:</label>
              <input type="password" className="form-control" name="password2" onChange={handleChange} value={userData.password2}></input>
            </div> */}
            <div className="register-field">
              <label htmlFor="floatingPassword2">{t("repeatPassword")}</label>
              <input type="password" className="form-control" id="floatingPassword2" placeholder={t("repeatPasswordPlaceholder")} name="password2" onChange={handleChange} value={userData.password2}></input>
            </div>

            <div className="recaptcha">
            {/* <label for="recaptcha">kod reCaptcha:</label> */}
            <ReCAPTCHA sitekey={process.env.REACT_APP_RECAPTCHA_KEY} onChange={handleRecaptcha} />
            </div>
            {loading == true ? <div className="loader"></div> 
            :
            registerSuccess === true ? <div className="loader"></div>
            :
            <button type="submit">{t("registerSubmit")}</button>
            }
          </form>
          <p className="register-error">{error}</p>
          <p className="register-login-link">{t("haveAccount")} <Link to={"/logowanie"}>{t("loginSubmit")}</Link></p>
            </section>
            <aside className="register-social-section"><h2>{t("registerGoogleTitle")}</h2><p>{t("registerGoogleIntro")}</p><div className="register-google"><LoginGoogle loginResponse={loginResponse} textKey="registerWithGoogle" /></div></aside>
          </div>
        </main>
    );
      }
};

export default Register;